import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Switch, useParams, useLocation } from "react-router-dom";
import React from "react";
import Registration from './../Pages/Registration.jsx';
import SuccessRegistration from './../Pages/SuccessRegistration.jsx';
import SuccessLogin from './../Pages/SuccessLogin.jsx';
import Empty from '../Pages/NotFound.jsx';
import { Routes } from './../Core/Constants';
import Login from './../Pages/Login.jsx';
import Cart from './../Pages/Cart.jsx';
import Checkout from './../Pages/Checkout.jsx';
import CheckoutUser from './../Pages/CheckoutUser.jsx';
import CheckoutFinish from './../Pages/CheckoutFinish.jsx';
import CheckoutRepeatPayment from './../Pages/CheckoutRepeatPayment.jsx';
import ChangePassword from './../Pages/ChangePassword.jsx';
import ConfirmPassword from '../Pages/confirmPassword.jsx';
import LostPassword from '../Pages/LostPassword.jsx';
import Orders from '../Pages/Orders.jsx';
import EditUser from '../Pages/EditUser.jsx';
import Order from './../Pages/Order.jsx';
import OrderView from '../Pages/OrderView.jsx';
import ReturnRequest from '../Pages/ReturnRequest.jsx';
import queryString from 'query-string';

export default class HomeRouter extends React.Component {

	state = {
		loading:false
	}

	render() {
		
		if (this.state.loading)
			return null;

        return (
			<Router >
				<Switch>
					<Route path={Routes.Register}>
						<Registration />
					</Route>
					<Route path={Routes.Login}>
						<Login />
					</Route>
					<Route path={Routes.CheckoutFinish}>
						<CheckoutFinish />
					</Route>
					<Route path={Routes.CheckoutUser}>
						<CheckoutUser />
					</Route>
					<Route path={Routes.Checkout}>
						<Checkout />
					</Route>
					<Route path={Routes.CheckoutRepeatPayment + '/:invc/:time'}>
						<ShowRepeatPayment />
					</Route>
					<Route path={Routes.SucessRegistration}>
						<SuccessRegistration />
					</Route>
					<Route path={Routes.SuccessLogin}>
						<SuccessLogin />
					</Route>
					<Route path={Routes.Cart}>
						<Cart />
					</Route>
					<Route path={Routes.ConfirmPassword}>
						<ShowResetPassword />
					</Route>
					<Route path={Routes.LostPassword}>
						<LostPassword />
					</Route>
					<Route path={Routes.Order + '/:id'}>
						<ShowOrder />
					</Route>
					<Route path={Routes.OrderView + '/:invc/:time'}>
						<ShowOrderView />
					</Route>
					<Route path={Routes.Orders}>
						<Orders />
					</Route>
					<Route path={Routes.EditUser}>
						<EditUser />
					</Route>
					<Route path={Routes.ChangePassword}>
						<ChangePassword />
					</Route>
					<Route path={Routes.ReturnRequestPaths}>
						<ShowReturnRequest />
					</Route>
					<Route >
						<Empty />
					</Route>
				</Switch>   
			</Router>
        );
    }
}

function ShowRepeatPayment() {
	let { invc, time } = useParams();
	return <CheckoutRepeatPayment invc={invc} time={time} />;
}

function ShowOrder() {
	let { id } = useParams();
	let location = useLocation();
	let params = queryString.parse(location.search);
	return <Order id={id} token={params.token} />;
}

function ShowOrderView() {
	let { invc, time } = useParams();
	return <OrderView invc={invc} time={time} />;
}

function ShowResetPassword() {
	let location = useLocation();
	let params = queryString.parse(location.search);
	return <ConfirmPassword userId={params.userId} token={params.token} />;
}

function ShowReturnRequest() {
	let location = useLocation();
	let params = queryString.parse(location.search);
	return <ReturnRequest token={params.token} />;
}

const element = document.getElementById("app");
var routerprefix;
if (element) {
	routerprefix = element.getAttribute('data-routerprefix');
}

if (element) {
	ReactDOM.render(<HomeRouter routerprefix = {routerprefix} />, element);		
}
